// extracted by css-extract-rspack-plugin
export default {"LayoutHeader":"Layout-module__LayoutHeader__x23GPBo"};